"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "flex__FlexContainer",
  componentId: "sc-105cfvb-0"
})(["display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;flex-flow:", ";width:100%;", " label{flex-basis:100%;}"], function (props) {
  return props.row ? "row" : "column";
}, function (props) {
  return props.row ? "> * { padding-right: 20px; &:last-child { padding-right: 0; } } " : "";
});

var _default = FlexContainer;
exports["default"] = _default;